<template>
  <div class="calendar">
    <div class="calendar_day calendar_day--weekday">Lunes</div>
    <div class="calendar_day calendar_day--weekday">Martes</div>
    <div class="calendar_day calendar_day--weekday">Miércoles</div>
    <div class="calendar_day calendar_day--weekday">Jueves</div>
    <div class="calendar_day calendar_day--weekday">Viernes</div>
    <div class="calendar_day calendar_day--weekday">Sábado</div>
    <div class="calendar_day calendar_day--weekday">Domingo</div>
    <div v-for="num in startWeekDay" :key="`${num}_filling`" class="calendar_day"></div>
    <ProgramarDiaComponent 
      v-for="num in numDays" 
      :key="num" 
      class="calendar_day" 
      :data-day="num"
      :num="num"
      :guias="guias"
      :month="month"
      :idModule="idModule"
      :calendario="calendario"
    />
  </div>
</template>
<script>
import ProgramarDiaComponent from '@/views/programacion/guias/ProgramarDiaComponent';
export default {
  props: {
    startWeekDay: Number,
    sundays: Array,
    numDays: Number,
    guias: Array,
    idModule: Number,
    month: String,
    calendario: Array,
  },
  components: {
    ProgramarDiaComponent
  },
}
</script>

<style lang="scss" scoped>
  .calendar {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-template-rows: auto repeat(5, minmax(100px, auto));
    grid-auto-rows: minmax(100px, auto);
    column-gap: 2px;
    row-gap: 2px;
    &_day {
      position: relative;
      background: #f5f5fb;
      overflow-y: auto;
      padding: 8px 30px 8px 15px;

      &#{&}--weekday {
        padding: 8px 0px;
        text-align: center;
        background: #ffe7b8;
      }

      &::before {
        content: attr(data-day);
        display: block;
        position: absolute;
        right: 5px;
        top: 5px;
        color: rgba(#000, .3);
        font-weight: 500;
        font-size: 18px;
        overflow: hidden;
      }
    }
  }
</style>